import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDm8dQktLoVNf_el_ISkSriaQOnGyDram4",
  authDomain: "lottecastle-e7928.firebaseapp.com",
  projectId: "lottecastle-e7928",
  storageBucket: "lottecastle-e7928.firebasestorage.app",
  messagingSenderId: "860207078943",
  appId: "1:860207078943:web:c883fd11c3193f70497f2a",
  measurementId: "G-QLGNLG0L0S"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
